import { getQcOffer, searchCount } from "@/store/services/filter/filterService";
import { searchOffer } from "@/store/services/offerService";
import { OfferSearch } from "@/types";
import {
  buildDashboardMetrics,
  DashboardMetrics,
  DashboardOfferRow,
} from "@/utils/homeDashboardMetrics";

export async function fetchDashboardOffers(
  filter: OfferSearch
): Promise<DashboardOfferRow[]> {
  const qcFilter = getQcOffer(filter);
  const countResponse: any = await searchCount({
    businessData: qcFilter,
  });
  const total = Number(countResponse?.count || 0);

  if (!total) {
    return [];
  }

  return (await searchOffer(filter, 0, total)) as DashboardOfferRow[];
}

export async function fetchDashboardMetrics(
  filter: OfferSearch
): Promise<DashboardMetrics> {
  const rows = await fetchDashboardOffers(filter);
  return buildDashboardMetrics(rows);
}
